import React from "react";
import { Link } from "react-router-dom";
import MusicShell from "../fanHome/MusicShell";
import { ACCENT } from "../artistStudio/shared";

// /rights/commercial-use (mobile design, screen 41): what each licence class lets you do with a sound. The wording matches the
// licence card on the Sound page; whether a class is offered, and its price, is set by the artist for each track.
const CLASSES = [
  { name: "Personal", badge: "Free on most sounds", text: "For private, non-monetised use.", points: ["Use in your own private, non-monetised content", "No ads or income from the content that uses the sound"] },
  { name: "Creator", badge: "From the artist's price", text: "For eligible creator use, including monetised content where the licence covers it.", points: ["Monetised creator content on any platform", "Sponsored posts under 100K followers", "Credit the artist and the sound title"] },
  { name: "Business", badge: "From the artist's price", text: "For business and brand promotional use, such as campaigns, ads and company videos.", points: ["Ads, brand campaigns and client work", "Unlimited reach, all platforms", "Credit optional"] },
];

export default function CommercialUse() {
  return (
    <MusicShell maxWidth="max-w-3xl">
      <Link to="/rights" className="text-sm font-semibold hover:underline" style={{ color: ACCENT }}>← Rights &amp; legal</Link>
      <h1 className="mt-3 text-2xl md:text-3xl font-bold text-gray-900">Commercial use</h1>
      <p className="mt-1 text-gray-600">What each licence lets you do with a sound. Availability is set by the artist for each track.</p>
      <div className="mt-6 space-y-4">
        {CLASSES.map((c) => (
          <section key={c.name} className="rounded-2xl border border-gray-200 bg-white p-5" data-testid={`class-${c.name.toLowerCase()}`}>
            <div className="flex items-center justify-between gap-3">
              <h2 className="text-lg font-bold text-gray-900">{c.name}</h2>
              <span className="rounded-full bg-[#e9f4ec] px-3 py-1 text-xs font-semibold" style={{ color: ACCENT }}>{c.badge}</span>
            </div>
            <p className="mt-2 text-sm text-gray-700">{c.text}</p>
            <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-gray-700">{c.points.map((p) => <li key={p}>{p}</li>)}</ul>
          </section>
        ))}
      </div>
      <p className="mt-5 text-sm text-gray-600">A Personal licence does not give you Creator or Business rights. Monetised use needs a Creator licence, and brand or business promotion needs a Business licence.</p>
    </MusicShell>
  );
}
